import React from "react";
import { Link, useLocation } from "react-router-dom";
// import { routeConfig } from "../i18nWrapper/Routes";
// import routeConfig from "../routes/routeConfig";
const routeConfig = [
  { en: "/", es: "/" },
  { en: "/bespoke", es: "/diseno-joyas-a-medida" },
  { en: "/account/:value", es: "/cuenta/:value" },
  { en: "/invoice/:order_id", es: "/factura/:order_id" },
  { en: "/register", es: "/register" },
  {
    en: "/engagement-rings",
    es: "/anillos-de-compromiso",
  },
  {
    en: "/engagement-rings/:stone",
    es: "/engagement-rings/:stone",
  },
  {
    en: "/ringsettingdetail/:id/:slug",
    es: "/ringsettingdetail/:id/:slug",
  },
  {
    en: "/band-builder",
    es: "/band-builder",
  },
  { en: "/gemstones", es: "/gemstones" },
  {
    en: "/gemstones/:subcategory",
    es: "/gemstones/:subcategory",
  },
  {
    en: "/fancy-color-diamond-animesh",
    es: "/fancy-color-diamond",
  },
  {
    en: "/fancy-color-diamond-detail/:stock_no",
    es: "/fancy-color-diamond-detail/:stock_no",
  },
  {
    en: "/diamonds",
    es: "/diamonds",
  },
  {
    en: "/diamonds/lab/:subcategory",
    es: "/diamonds/lab/:subcategory",
  },
  {
    en: "/diamonds/:subcategory",
    es: "/diamonds/:subcategory",
  },
  { en: "/watches", es: "/watches" },
  {
    en: "/watches/:brand",
    es: "/watches/:brand",
  },
  {
    en: "/diamonds-details/:stock_no",
    es: "/diamonds-details/:stock_no",
  },
  {
    en: "/gemstone-details/:stock_no",
    es: "/gemstone-details/:stock_no",
  },
  {
    en: "/watch-details/:stock_no",
    es: "/watch-details/:stock_no",
  },
  {
    en: "/complete-diamond-ring",
    es: "/complete-diamond-ring",
  },
  {
    en: "/complete-gemstone-ring",
    es: "/complete-gemstone-ring",
  },
  {
    en: "/complete-fancycolor-ring",
    es: "/complete-fancycolor-ring",
  },
  {
    en: "/search/:search_text",
    es: "/buscar/:search_text",
  },
  { en: "/cart", es: "/carrito" },
  {
    en: "/checkout-shipping",
    es: "/finalizar-compra-envio",
  },
  {
    en: "/custom-design",
    es: "/taller-artesania",
  },
  {
    en: "/certified-diamonds",
    es: "/diamantes-certificados",
  },
  {
    en: "/jewelry-insurance",
    es: "/seguro-joyas",
  },
  {
    en: "/events-proposal",
    es: "/pedidas-de-mano",
  },
  { en: "/financing", es: "/financing" },
  {
    en: "/make-an-appointment",
    es: "/cita-previa",
  },
  {
    en: "/testimonials",
    es: "/testimonials",
  },
  {
    en: "/terms-and-conditions",
    es: "/terminos-condiciones",
  },
  {
    en: "/terms-conditions-redsys",
    es: "/terminos-condiciones-redsys",
  },
  {
    en: "/privacy-policy",
    es: "/politica-privacidad",
  },
  {
    en: "/returns-and-exchanges",
    es: "/cambios-y-devoluciones",
  },
  { en: "/cookies", es: "/cookies" },
  { en: "/payment", es: "/metodos-pago" },
  { en: "/contact", es: "/contacto" },
  { en: "/about", es: "/manuel-spinosa-historia" },
  { en: "/blog", es: "/blog" },
  { en: "/faq", es: "/faq" },
  {
    en: "/blog-details/:url",
    es: "/blog-details/:url",
  },
  {
    en: "/productdetail/:slug",
    es: "/productdetail/:slug",
  },
  { en: "/success", es: "/pago-realizado" },
  {
    en: "/failure",
    es: "/pago-fallido",
  },
  {
    en: "/redsyspaymentproccess",
    es: "/redsyspaymentproccess",
  },
  {
    en: "/payment_pending",
    es: "/payment_pending",
  },
  {
    en: "/payment_dismiss",
    es: "/payment_dismiss",
  },
  {
    en: "/payment_error",
    es: "/payment_error",
  },
  {
    en: "/aplazame_ko",
    es: "/aplazame_ko",
  },
  {
    en: "/ordersuccess",
    es: "/ordersuccess",
  },
  {
    en: "/fine-jewelry",
    es: "/joyeria-fina",
  },
  {
    en: "/wedding-rings",
    es: "/alianzas-de-boda",
  },
  {
    en: "/fine-jewelry/:subcategory",
    es: "/joyeria-fina/:subcategory",
  },
  {
    en: "/wedding-rings/:subcategory",
    es: "/alianzas-de-boda/:subcategory",
  },
  {
    en: "/education/gemstone-education",
    es: "/guia/piedras-preciosas",
  },
  {
    en: "/education/engagement-ring-education",
    es: "/guia/anillos-compromiso",
  },
  {
    en: "/education/wedding-ring-education",
    es: "/guia/alianzas-boda",
  },
  {
    en: "/education/fine-jewelry-education",
    es: "/education/fine-jewelry-education",
  },
  {
    en: "/education/loose-diamonds-education",
    es: "/guia/diamantes-sueltos",
  },
  { en: "/education", es: "/guia-diamantes" },
  {
    en: "/stud-settingdetail/:id/:slug",
    es: "/stud-settingdetail/:id/:slug",
  },
  {
    en: "/stud-diamonds-details/:pairId",
    es: "/stud-diamonds-details/:pairId",
  },
  {
    en: "/stud-settings",
    es: "/stud-settings",
  },
  {
    en: "/stud-settings/:stone",
    es: "/stud-settings/:stone",
  },
  {
    en: "/stud-diamonds",
    es: "/stud-diamonds",
  },
  {
    en: "/stud-diamonds/lab",
    es: "/stud-diamonds/lab",
  },
  {
    en: "/complete-diamond-stud",
    es: "/complete-diamond-stud",
  },
  { en: "*", es: "*" },
];
/**
 * Matches a concrete path against a route pattern containing :param segments.
 * Returns the matched route and extracted param values, or null.
 */
function matchPatternRoute(path) {
  for (const route of routeConfig) {
    if (!route.en.includes(":")) continue;
    const pattern = route.en.replace(/:[^/]+/g, "([^/]+)");
    const regex = new RegExp(`^${pattern}$`);
    if (regex.test(path)) return route;
  }
  return null;
}

function buildLocalizedPath(enPattern, esPattern, actualPath) {
  const enParts = enPattern.split("/");
  const actualParts = actualPath.split("/");
  const esParts = esPattern.split("/");

  return esParts
    .map((part, i) => {
      if (part.startsWith(":")) {
        const paramIndex = enParts.indexOf(part);
        return paramIndex !== -1 ? actualParts[paramIndex] : actualParts[i];
      }
      return part;
    })
    .join("/");
}

const LocalizedLink = ({ to, children, ...props }) => {
  const location = useLocation();
  const trimmedTo = (to || "").trim();

  const lang = location.pathname.startsWith("/es") ? "es" : "en";

  let path = trimmedTo;
  const exactRoute = routeConfig.find((r) => r.en === trimmedTo);

  if (exactRoute) {
    path = exactRoute[lang];
  } else {
    const patternRoute = matchPatternRoute(trimmedTo);
    if (patternRoute) {
      path = buildLocalizedPath(patternRoute.en, patternRoute[lang], trimmedTo);
    }
  }

  return (
    <Link to={`/${lang}${path}`} {...props}>
      {children}
    </Link>
  );
};

export default LocalizedLink;
